import { Box, FormControl, Paper } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
export const ProvidersContainer = styled.div``;
export const StyledPaper = styled(Paper)`
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;

export const GameDetailsContainer = styled(Paper)`
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 20px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
`;

export const TeamRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const ChipContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

export const StyledFormControl = styled(FormControl)`
  margin: 10px;
  padding: 10px;
`;
export const StyledDiv = styled.div`
  margin: 10px;
`;
